/* cl-mega.js (feelingirl, retrabalho 10-08): megamenu do Prestige 10 dele sobre o header nativo do Shrine.
   Cada <details> do nav cujo rotulo bate com um painel do <template id="cl-mega-tpl"> troca o <ul> do dropdown
   do Dawn pelo painel dele; abre no HOVER (trigger="hover" dele), fecha ao sair; clicar no rotulo segue o link
   da colecao (follow-summary-link dele) quando ha um. Gaveta mobile: titulos de coluna com url "/" viram rotulo. */
(function () {
  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function init() {
    var tpl = document.getElementById('cl-mega-tpl');
    if (!tpl) return;
    var panels = {};
    tpl.content.querySelectorAll('[data-cl-mega]').forEach(function (p) { panels[norm(p.getAttribute('data-cl-mega'))] = p; });
    document.querySelectorAll('.header__inline-menu header-menu > details').forEach(function (d) {
      if (d.__clm) return;
      var s = d.querySelector(':scope > summary');
      var p = s && panels[norm(s.textContent)];
      if (!p) return;
      d.__clm = 1;
      var panel = p.firstElementChild.cloneNode(true);
      var ul = d.querySelector(':scope > ul');
      if (ul) ul.remove();
      d.appendChild(panel);
      var li = d.closest('li');
      if (panel.classList.contains('cl-dd') && li) li.classList.add('cl-has-dd');
      var follow = p.getAttribute('data-follow');
      var t;
      function open() {
        clearTimeout(t);
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (o) { if (o !== d) o.open = false; });
        d.open = true; s.setAttribute('aria-expanded', 'true');
      }
      function close() { t = setTimeout(function () { d.open = false; s.setAttribute('aria-expanded', 'false'); }, 120); }
      (li || d).addEventListener('mouseenter', open);
      (li || d).addEventListener('mouseleave', close);
      s.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (follow && matchMedia('(hover: hover)').matches) { location.href = follow; return; }
        if (d.open) { d.open = false; } else open();
      }, true);
      panel.addEventListener('click', function (e) { if (e.target.closest('a[data-cl-nolink]')) e.preventDefault(); });
    });
    /* gaveta mobile: a lista do Shrine (submenus deslizantes, titulos de coluna linkando "/") da lugar ao
       header-sidebar dele: acordeao de 1o nivel + sub-acordeoes <details> + fotos de promo */
    var sb = tpl.content.querySelector('[data-cl-sidebar] > .cl-sb');
    var nav = document.querySelector('.menu-drawer__navigation');
    if (sb && nav && !nav.querySelector('.cl-sb')) {
      var old = nav.querySelector(':scope > .menu-drawer__menu');
      var mine = sb.cloneNode(true);
      if (old) old.replaceWith(mine); else nav.appendChild(mine);
      mine.querySelectorAll('.cl-sb-sub').forEach(function (u) {
        var b = u.previousElementSibling;
        if (!b || !b.matches('button.cl-sb-btn')) return;
        u.hidden = b.getAttribute('aria-expanded') !== 'true';
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var open = b.getAttribute('aria-expanded') === 'true';
          b.setAttribute('aria-expanded', open ? 'false' : 'true');
          b.classList.toggle('is-open', !open);
          u.hidden = open;
        });
      });
    }
    document.querySelectorAll('.menu-drawer a[href="/"]').forEach(function (a) {
      if (!a.closest('.menu-drawer__submenu, .menu-drawer__inner-submenu')) return;
      var h = document.createElement('span');
      h.className = 'cl-drawer-heading'; h.textContent = a.textContent.trim();
      a.replaceWith(h);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
